var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_372_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9718 16.0054L7.50709 15.607C6.86643 15.0706 1.27246 10.2394 1.27246 6.70554C1.27246 3.0056 4.27187 0.00619507 7.9718 0.00619507C11.6717 0.00619507 14.6711 3.0056 14.6711 6.70554C14.6711 10.2394 9.07718 15.0706 8.43918 15.6097L7.9718 16.0054ZM7.9718 1.45479C5.07327 1.45807 2.72437 3.80698 2.72109 6.70551C2.72109 8.92557 6.16271 12.4721 7.9718 14.0953C9.78093 12.4714 13.2225 8.92288 13.2225 6.70551C13.2192 3.80698 10.8704 1.4581 7.9718 1.45479Z",
    fill: "#0236EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97197 9.3611C6.50534 9.3611 5.31641 8.17216 5.31641 6.70553C5.31641 5.23891 6.50534 4.04997 7.97197 4.04997C9.43859 4.04997 10.6275 5.23891 10.6275 6.70553C10.6275 8.17216 9.43862 9.3611 7.97197 9.3611ZM7.97197 5.37772C7.23866 5.37772 6.64419 5.97219 6.64419 6.7055C6.64419 7.43882 7.23866 8.03329 7.97197 8.03329C8.70528 8.03329 9.29975 7.43882 9.29975 6.7055C9.29975 5.97219 8.70531 5.37772 7.97197 5.37772Z",
    fill: "#0236EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_372_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.adedccb0056b809fdd74b2e0259b35e4.svg";
export { ForwardRef as ReactComponent };